import {
  Label,
  InfoButton,
} from "@tandemdiabetes/sugarmate-react-components"
import styles from "./PhoneCallAlerts.module.scss"
import { SleepHoursModal } from "./SleepHoursModal"
import {
  useFollowedUsers,
  usePolyglot,
} from "src/contexts"
import { useDisplayTime } from "src/hooks"
import {
  sleepSettingToTime,
  followToSharer,
} from "src/utils"

export function SleepHours() {
  const polyglot = usePolyglot()
  const displayTime = useDisplayTime()

  const { currentFollow } = useFollowedUsers()
  const sleepSettings = currentFollow.sleep_settings

  const polyglotPrefix = currentFollow.is_self
    ? "pages.alerts.phone_call.sleep_hours."
    : "pages.alerts.phone_call.sleep_hours_sharer."

  return (
    <div>
      <div className={styles.labelRow}>
        <Label>
          {polyglot.t(
            `${polyglotPrefix}label`,
            currentFollow.is_self
              ? undefined
              : { name: followToSharer(currentFollow) },
          )}
          <InfoButton title={polyglot.t(`${polyglotPrefix}title`)}>
            <div>
              {polyglot.t(`${polyglotPrefix}description_one`)}
            </div>
            <div>
              {polyglot.t(`${polyglotPrefix}description_two`)}
            </div>
          </InfoButton>
        </Label>
        {currentFollow.is_self && <SleepHoursModal />}
      </div>
      <div className={styles.sleepHoursContainer}>
        <span className={styles.sleepHoursText}>
          {displayTime(sleepSettingToTime(sleepSettings["start_time"]))}
        </span>
        <span className={styles.sleepHoursText}>
          –
        </span>
        <span className={styles.sleepHoursText}>
          {displayTime(sleepSettingToTime(sleepSettings["end_time"]))}
        </span>
      </div>
    </div>
  )
}
